<ng-template #content let-offcanvas>
  <div class="slider-container">
    <div class="flex-row-container">
      <h2>Filters</h2>
      <button class="close-button" (click)="close(content)" id="close-filters-button">
        <span class="visuallyhidden">Close filters</span>
        <i class="ico-cancel" aria-hidden="true"></i>
      </button>
    </div>
    <ng-content></ng-content>
  </div>
</ng-template>

<button appButton="small" class="open-button" (click)="open(content)" id="open-filters-button">
  <fa-icon aria-hidden="true" [icon]="sliderIcon"></fa-icon>
  Select
  <span class="visuallyhidden">Open filters</span>
</button>
